import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CloudRecordingStatus } from '../../../../types';

type CloudRecordingState = {
    cloudRecordingStatus: CloudRecordingStatus;
    isStopModalOpened: boolean;
};

const initialState: CloudRecordingState = {
    cloudRecordingStatus: 'TURNED_OFF',
    isStopModalOpened: false,
};

const cloudRecordingSlice = createSlice({
    name: 'cloudRecording',
    initialState,
    reducers: {
        setCloudRecordingStatus(state, action: PayloadAction<CloudRecordingStatus>) {
            state.cloudRecordingStatus = action.payload;
        },
        resetCloudRecordingState() {
            return initialState;
        },
        setIsCloudRecordingStopModalOpened(state, action: PayloadAction<boolean>) {
            state.isStopModalOpened = action.payload;
        },
    },
});
export const { setCloudRecordingStatus, resetCloudRecordingState, setIsCloudRecordingStopModalOpened } =
    cloudRecordingSlice.actions;
export const cloudRecordingReducer = cloudRecordingSlice.reducer;

export const startCloudRecordingAction = createAction<void>('cloudRecording/start');
export const stopCloudRecordingAction = createAction<void>('cloudRecording/stop');
export const closeCloudRecordingStopModalAction = createAction<boolean>('cloudRecording/closeStopModal');
